import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseChargesAdjustmentTemplates = [
  {
    id: '-204001',
    language: Language.EN,
    subject: 'Charge provision adjustment',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>We are adjusting your provisions from {{getLphPreviousMonthlyCharges leasePriceHistory}} € to {{adjustmentAmount}} €.</p>
          <p>Thank you for adjusting your direct debit.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-204002',
    language: Language.FR,
    subject: 'Ajustement des provisions de charges',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Nous ajustons vos provisions de {{getLphPreviousMonthlyCharges leasePriceHistory}} € à {{adjustmentAmount}} €.</p>
          <p>Merci d'ajuster votre domiciliation périodique.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-204003',
    language: Language.NL,
    subject: 'Aanpassing van de provisies voor lasten',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Wij passen uw voorschotten aan van {{getLphPreviousMonthlyCharges leasePriceHistory}} € naar {{adjustmentAmount}} €.</p>
          <p>Dank u voor het aanpassen van uw domiciliëring.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-204004',
    language: Language.DE,
    subject: 'Anpassung der Nebenkostenvorauszahlungen',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Wir passen Ihre Vorauszahlungen von {{getLphPreviousMonthlyCharges leasePriceHistory}} € auf {{adjustmentAmount}} € an.</p>
          <p>Bitte passen Sie Ihren Dauerauftrag an.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
